import { permissions } from '../constants/permissions';
import useAccountStore from '../store/accountStore';

const usePermissions = () => {
  const { role, teamId } = useAccountStore((state) => state.activeAccount);
  const hasPermission = (action) => {
    const allowedRoles = permissions[action];

    return allowedRoles.includes(role);
  };

  const isTeamAllowed = () => !!teamId;

  return { hasPermission, isTeamAllowed };
};

export default usePermissions;
